<template>
  <div>
    <Cover
      header=""
      text=""
      :backgroundImagePath="require('../assets/imgs/cover.png')"
    />

    <ListWithRectangles
    :items="productsItems"
    title="Продукты в едином реестре российского ПО"
    theme="dark"
    />

    <HorizontalCardsBlock :items="horizontalCardsBlockItems" />
  </div>
</template>

<script>
    import {Cover, HorizontalCardsBlock, ListWithRectangles} from 'sputnik-ui/src/index';
    import { changeUrl } from '../utils/changeUrl'

    export default {
      name: 'HomePage',
      components: {
        Cover,
        HorizontalCardsBlock,
        ListWithRectangles
      },
      data() {
        return {
          horizontalCardsBlockItems: [
            {
              header: 'Сканер уязвимостей',
              text: 'Коробочное решение и сервис по подписке по поиску уязвимостей web и IoT',
              imagePosition: 'left',
              imagePath: require('@/assets/imgs/scanner-mini.png'),
              onClick: () => {changeUrl('/scanner')}
            },
            {
              header: 'Сервис поиска устройств IoT',
              text: 'Быстрое и точное выявление уязвимых устройств',
              imagePosition: 'right',
              imagePath: require('@/assets/imgs/search-mini.png'),
              onClick: () => {changeUrl('/search-for-devices')}
            },
            {
              header: 'Сервис аналитики',
              text: 'Бесплатный публичный сервис. 171 Указ Президента.',
              imagePosition: 'left',
              imagePath: require('@/assets/imgs/analytics-mini.png'),
              onClick: () => {changeUrl('/analytics')}
            },
            {
              header: 'Профиль клиента',
              text: 'Решение для построения профилей физических лиц для последующей аналитики и маркетингового анализа',
              imagePosition: 'right',
              imagePath: require('@/assets/imgs/client-profile-mini.png'),
              onClick: () => {changeUrl('/client-profile')}
            },
            {
              header: 'Обезличивание',
              text: 'SDK для обезличивания и маскирования данных с целью обеспечения безопасности данных',
              imagePosition: 'left',
              imagePath: require('@/assets/imgs/depersonalization-mini.png'),
              onClick: () => {changeUrl('/depersonalization')}
            },
            {
              header: 'Генератор синтетических данных',
              text: 'Методы генерации синтетических персональных данных для тестовых сред',
              imagePosition: 'right',
              imagePath: require('@/assets/imgs/data-generator-mini.png'),
              onClick: () => {changeUrl('/data-generator')}
            },
            // {
            //   header: 'Сервис поиска датасетов',
            //   text: 'Интеллектуальная платформа для поиска, анализа и конструирования открытых наборов данных, готовых к безопасному использованию в системах ИИ.',
            //   imagePosition: 'left',
            //   imagePath: require('@/assets/imgs/search-for-datasets-mini.png'),
            //   onClick: () => {changeUrl('/search-for-datasets')}
            // },
          ],
          productsItems: [
            { text: 'Корпоративный поиск «Спутник»', onClick: () => { window.open('https://reestr.digital.gov.ru/reestr/304842/?sphrase_id=6512896', '_blank') } },
            { text: 'Аналитическая система «Спутник»', onClick: () => { window.open('https://reestr.digital.gov.ru/reestr/303283/?sphrase_id=6512907', '_blank') } },
          ],
        }
      }
    };
</script>

<style lang="scss">
  .cover-wrapper .cover {
    background-color: initial;
  }
</style>
